import script from "./BlogPostView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostView.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostView.vue?vue&type=style&index=0&id=09983157&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09983157"]])

export default __exports__